import { noop } from 'lodash/fp';

import FormReviewInquiry from 'dashboard/forms/FormReviewInquiry';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { Inquiry, InquiryReview } from 'dashboard/models/inquiry';

interface ReviewInquiryModalProps {
  handleCancel?: () => void;
  handleSubmitReview?: (review: InquiryReview) => void;
  inquiry: Inquiry;
}

const ReviewInquiryModal = ({
  handleCancel,
  handleSubmitReview,
  inquiry,
}: ReviewInquiryModalProps) => (
  <ModalContainer data-test='review-inquiry-modal'>
    <ModalHeader data-test='review-inquiry-modal__header' onClose={handleCancel}>
      Review Inquiry
    </ModalHeader>

    <ModalBody>
      <FormReviewInquiry
        handleCancel={handleCancel ?? noop}
        inquiry={inquiry}
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        onSubmit={handleSubmitReview}
      />
    </ModalBody>
  </ModalContainer>
);

export default ReviewInquiryModal;
